var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarTableComparison = function SvgStarTableComparison(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 18,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.264 0 2.305 6.856h7.458l-6.034 4.238 2.305 6.856-6.033-4.238L4.23 17.95l2.305-6.856L.502 6.856H7.96L10.264 0Z",
    fill: "#F7A000"
  })));
};
export { SvgStarTableComparison as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMSIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDIxIDE4IiBmaWxsPSJjdXJyZW50Q29sb3IiPgo8cGF0aCBkPSJNMTAuMjY0NSAwTDEyLjU2OSA2Ljg1NjE2SDIwLjAyNjZMMTMuOTkzMyAxMS4wOTM1TDE2LjI5NzggMTcuOTQ5N0wxMC4yNjQ1IDEzLjcxMjNMNC4yMzExNyAxNy45NDk3TDYuNTM1NjkgMTEuMDkzNUwwLjUwMjM3OSA2Ljg1NjE2SDcuOTU5OTZMMTAuMjY0NSAwWiIgZmlsbD0iI0Y3QTAwMCIvPgo8L3N2Zz4=";